export const USER_NOT_FOUND = 'userNotFound';
export const NOT_FOUND = 'notFound';



// WEBPACK FOOTER //
// ./src/firebase/errorTypes.js